import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _wq: any;
  }
}

window._wq = window._wq || [];

@Component({
    selector: 'sentry-wista-video',
    templateUrl: './wista-video.component.html',
    styleUrls: ['./wista-video.component.scss'],
    standalone: true
})
export class WistaVideoComponent implements AfterViewInit {
  @Input() videoId: string | null = null;
  @Output() finished$ = new EventEmitter<void>();

  constructor(private readonly elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    console.log(this.videoId);
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = `https://fast.wistia.com/embed/medias/${this.videoId}.jsonp`;
    this.elementRef.nativeElement.appendChild(s);

    const f = document.createElement('script');
    f.type = 'text/javascript';
    f.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    this.elementRef.nativeElement.appendChild(f);

    window._wq = window._wq || [];
    window._wq.push({
      id: '_all',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onReady: (video: any) => {
        video.bind('end', () => {
          this.finished$.emit();
        });
      },
    });
  }
}
